import { ComponentProps } from 'react'

import clsx from 'clsx'
import { tv } from 'tailwind-variants'

import type { IconName } from './IconNames'

export const iconVariants = tv({
  base: 'material-symbols-rounded !flex !items-center !justify-center !font-[300] !leading-none',
  variants: {
    size: {
      xs: '!text-[15px]',
      sm: '!text-[18px]',
      md: '!text-[21px]',
      lg: '!text-[24px]',
      inherit: '!text-[1.5em]'
    },
    color: {
      inherit: '',
      surface: 'text-surface-black-50',
      primary: 'text-primary-200',
      secondary: 'text-secondary-200',
      info: 'text-information-200',
      success: 'text-success-200',
      warning: 'text-warning-200',
      danger: 'text-danger-200',
      'surface-white': 'text-surface-white-400',
      white: 'text-surface-white-50'
    }
  },
  defaultVariants: {
    size: 'inherit',
    color: 'inherit'
  }
})

export type TIconProps = {
  name: IconName
  /**
   * Icon size
   * - `xs`    → 15px
   * - `sm`    → 18px
   * - `md`    → 21px
   * - `lg`    → 24px
   * - `inherit` → 1.5em
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'inherit'
  color?:
    | 'inherit'
    | 'surface'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'surface-white'
    | 'white'
} & ComponentProps<'span'>

/**
 * @deprecated Use `Icon` from `@alternative/acqua/atoms` instead. The acqua-ui V2 Icon is being phased out in favor of the acqua design system.
 */
export const Icon = ({
  name,
  size = 'inherit',
  color = 'inherit',
  className,
  ...rest
}: TIconProps): React.JSX.Element => (
  <span className={clsx(iconVariants({ size, color }), className)} {...rest}>
    {name}
  </span>
)
